/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useState, useEffect, useContext } from 'react';
import Alert from 'react-s-alert';
import { CountdownCircleTimer } from 'react-countdown-circle-timer';
import { Button, Form, FormGroup, Label, Input, Col, InputGroup, InputGroupAddon } from 'reactstrap';
import moment from 'moment';
import Joyride, { CallBackProps, STATUS, Step, StoreHelpers } from 'react-joyride';

// context imports
import { ThemeContext } from '../../../contexts/ThemeContext';

// service imports
import DemoService from '../../../services/DemoService';

// local imports
import ProviderNavbar from './ProviderNavbar';
import TimeoutSound from '../../../assets/TimeoutSound.wav';

const StartMeet = props => {

    let audio = new Audio(TimeoutSound);
    let audioCount = 1;
    audio.addEventListener('ended', function () {
        if (audioCount < 1) {
            audioCount += 1;
            this.currentTime = 0;
            this.play();
        }
    }, false)

    // states
    const [time, setTime] = useState(0);
    const [isPlaying, setIsPlaying] = useState(false);
    const [tutorial, setTutorial] = useState({
        status: false,
        steps: [
            {
                content: <h4>Here you can create your meeting using <b>Zoom</b> and <b>Google Meet</b>!</h4>,
                placement: 'center',
                target: '#startMeetDiv',
            }
        ]
    });
    let helpers = null;

    // contexts
    const { theme } = useContext(ThemeContext);

    // useEffect
    useEffect(() => {
        DemoService.getUserData().then(data => {
            if (data.isAuthenticated) {
                if (data.user.roles.includes("DemoProvider")) {
                    if (!data.user.demoTakenFor.includes("StartMeet")) {
                        setTutorial({ ...tutorial, status: true });
                    }
                    if (props.location.state) {
                        setTime(props.location.state.duration);
                    } else {
                        props.history.replace('/demo/sessions');
                    }
                } else {
                    props.history.replace('/demo/clientDashboard');
                }
            } else {
                props.history.replace('/demo/signin');
            }
        })
    }, [props.location.state]);


    // handle functions

    const handleJoyrideCallback = (data) => {
        const { status, type } = data;
        const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];

        if (finishedStatuses.includes(status)) {
            DemoService.markVisited("StartMeet");
            setTutorial({ ...tutorial, status: false });
        }
    };

    const getHelpers = (paramHelpers) => {
        helpers = paramHelpers;
    };

    //utility functions
    const renderTime = ({ remainingTime }) => {
        let hours = Math.floor(remainingTime / 3600)
        let minutes = Math.floor((remainingTime % 3600) / 60)
        let seconds = remainingTime % 60
        if (hours < 10) { hours = "0" + hours; }
        if (minutes < 10) { minutes = "0" + minutes; }
        if (seconds < 10) { seconds = "0" + seconds; }

        if (remainingTime === 0) {
            return <div style={{ fontSize: '2.5rem' }}>Timeout...</div>;
        }

        return (
            <div className="d-flex h-75 flex-column text-center">
                <div className="time mt-auto" style={{ fontSize: '2.5rem' }}>
                    {hours + ':' + minutes + ':' + seconds}
                </div>
                <div><text style={{ fontSize: '1.2rem' }}>remaining</text></div>
                <div className="mt-auto" style={{ cursor: 'pointer' }} onClick={() => { setIsPlaying(!isPlaying); audio.play(); }}>
                    {
                        isPlaying
                            ? <i className="fas fa-pause-circle" style={{ fontSize: "2.5rem" }}></i>
                            : <i className="fas fa-play-circle" style={{ fontSize: "2.5rem" }}></i>
                    }
                </div>
            </div>
        );
    };

    return (
        <div id="startMeetDiv">
            <Joyride
                callback={handleJoyrideCallback}
                continuous={true}
                getHelpers={getHelpers}
                run={tutorial.status}
                scrollToFirstStep={true}
                showProgress={false}
                showSkipButton={false}
                steps={tutorial.steps}
                locale={{ last: 'Finish' }}
                styles={{
                    options: {
                        primaryColor: "rgb(56, 78, 115)",
                        zIndex: 10000,
                    },
                }}
            />
            <ProviderNavbar history={props.history} showTutorial={() => setTutorial({ ...tutorial, status: true })} />
            <div className="p-3">
                {time ?
                    <div className="d-flex justify-content-around">
                        <div id="counter">
                            <CountdownCircleTimer isPlaying={isPlaying} size={240} strokeWidth={10} duration={time * 60} colors={[['#004777', 0.33], ['#F7B801', 0.33], ['#A30000', 0.33]]}>
                                {renderTime}
                            </CountdownCircleTimer>
                        </div>
                        {/* <CountdownCircleTimer onComplete={() => [true,1000]} isPlaying={isPlaying} size={240} strokeWidth={10} duration={10} colors={[['#004777', 0.33],['#F7B801', 0.33],['#A30000', 0.33]]}>
                            {renderTime}
                        </CountdownCircleTimer> */}
                    </div> : null
                }
                <div className="d-flex justify-content-around mt-5">
                    <a href="https://meet.google.com/new" target="_blank">
                        <Button style={theme.formSubmit} id="meetBtn">Google Meet</Button>
                    </a>
                    <a href="https://zoom.us/start/videomeeting" target="_blank">
                        <Button style={theme.formSubmit} id="zoomBtn">Zoom</Button>
                    </a>
                </div>
            </div>
        </div>
    )

}

export default StartMeet;